<template>
	<div class="le-card">
		<div class="le-img">
			<router-link :to="{ name: 'news', params: { id: event.id } }">
				<div class="image">
					<img :src="event.primary_image" alt />
				</div>
			</router-link>
			<span>
				<i class="fas fa-calendar-alt"></i>
				{{ moment(event.updated_at) }}
			</span>
		</div>
		<p>{{ event.title }}</p>
		<btn
			:text="$t('read-more')"
			class="btno"
			theme="sub"
			:link="{ name: 'news', params: { id: event.id } }"></btn>
	</div>
</template>

<script>
import Button from './Button';
import { moment } from '@/helpers';
export default {
	components: {
		btn: Button,
	},

	methods: {
		moment,
	},

	props: ['event'],
};
</script>

<style scoped>
* {
}
.le-card {
	padding: 10px;
	height: 100%;
}
.le-img {
	width: 100%;
	position: relative;
	height: 200px;
}
.le-card .image {
	border-radius: 18px;
	overflow: hidden;
	width: 100%;
	height: 100%;
}
.image img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	transition: 1000ms;
}
.image img:hover {
	transform: scale(1.1);
}
.le-card span {
	display: block;
	position: absolute;
	right: 10px;
	bottom: 5px;
	width: max-content;
	font-size: 14px;
	color: white;
	direction: rtl;
}
.le-card span svg {
	width: 12px;
	margin: 0 2px;
	filter: brightness(0) invert(100%);
}
.le-card p {
	text-align: center;
	width: 100%;
	font-size: 16px;
	color: var(--font-color);
	margin: 10px 0;
	word-wrap: break-word;
	line-height: 18px;
	height: 54px;
	overflow: hidden;

	direction: rtl;
}
.le-card .btno {
	margin: 0 auto;
	width: max-content;
	transition: 200ms;
	font-size: 1;
}
@media only screen and (max-width: 992px) {
	.le-img {
		height: 250px;
	}
}
</style>
